// extracted by mini-css-extract-plugin
module.exports = {"background":"Meeting_background__19LH5","remote":"Meeting_remote__HHXhM","local":"Meeting_local__1LI1z","text":"Meeting_text__3sSOj","micIcon":"Meeting_micIcon__1av6J"};